import './Theme.Page.Static.2.scss';
export default `ThemePageStatic2`;
